import { Box, Typography, styled } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';

export const DpArticleCardGrid = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	alignContent: 'center',
	alignItems: 'center',
	justifyContent: 'space-between',
});

export const DpArticleCard = styled(Linkable)(({ theme }) => ({
	width: '30%',
	boxShadow: 'none',
	backgroundColor: '#FBFBFC',
	marginBottom: '20px',
	[theme.breakpoints.down('sm')]: {
		width: '100%',
	},
	'&:hover': {
		cursor: 'pointer',
	},
	alignSelf: 'start',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: theme.spacing(2),
	'& img': {
		width: '167px',
		height: '110px',
		[theme.breakpoints.up('sm')]: {
			width: '196px',
			height: '128px',
		},
	},
}));

const DpArticleCardBaseText = styled((props) => <Typography {...props} component="span" />)(
	({ theme }) => ({
		fontSize: 'var(--font-size-default)',
		fontWeight: 600,
		[theme.breakpoints.up('sm')]: {
			fontSize: 'var(--font-size-sm)',
		},
	})
);

export const DpArticleCardEmphasis = styled(DpArticleCardBaseText)({
	color: '#0467D2',
});

export const DpArticleCardText = styled(DpArticleCardBaseText)({
	color: '#000000',
});
